export const FlexibleHourEN = {
    "reasonFlexibleHour": {
        "title": "Manager flexible hour reason",
        "breadCrumb": "Manager flexible hour reason",
        "pageHeader": {
            "reasonFlexibleHour": "Manager flexible hour reason"
        }
    }
}
